import { dedupeIntegration, extraErrorDataIntegration, httpClientIntegration } from '@sentry/integrations'

export const sentryOptions = {
  dsn: 'https://11de51e753454212a2845e5899a38cae@sentry.io/33153',
  allowUrls: [/finviz\.com/, /www\.finviz\.com/, /elite\.finviz\.com/],
  release: typeof window !== 'undefined' && 'FinvizSentrySettings' in window ? FinvizSentrySettings.release : undefined,
  sendDefaultPii: true,
  integrations: [dedupeIntegration(), extraErrorDataIntegration(), httpClientIntegration()],

  ignoreErrors: [
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'ChunkLoadError: Loading chunk',
    'Error: Loading CSS chunk',
    /^TypeError: Load failed$/,
  ],
}
